import { connect } from 'react-redux'
import { actions as cartActions } from 'features/Cart'
import ActionButton from 'Shared/Button/ActionButton'

const AddToCartButton = connect(
  ({ cart, oidc }) => ({
    isLoading: cart.isLoadingRedirect,
    hasSuccess: cart.itemAdded,
    email: oidc && oidc.user && oidc.user.profile && oidc.user.profile.email
  }),
  (dispatch, { sku, vendorId, goToCheckout }) => ({
    onClick: email => () => dispatch(cartActions.addItem({ sku, vendorId, email }, goToCheckout))
  }),
  ({ email, ...stateProps }, { onClick }, own) => ({
    ...stateProps,
    onClick: onClick(email),
    ...own
  })
)(ActionButton)

AddToCartButton.defaultProps = {
  errorText: 'Erro ao adicionar',
  successText: 'Adicionado',
  text: 'Adicionar ao Carrinho',
  iconName: 'icon_cart'
}

export default AddToCartButton



// WEBPACK FOOTER //
// ./src/Checkout/Cart/AddToCartButton.js